<template>
  <div>
    <v-row class="py-0">
      <v-col cols="12" sm="6" md="3" xs="12" class="mr-md-4">
        <v-select
            :items="viewTypes"
            v-model="viewType"
            item-text="text"
            item-value="id"
            menu-props="auto"
            label="Tipo de visualização"
            hide-details
            single-line
            solo
            color="primary"
            dense
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3" xs="12" class="mr-md-4">
        <v-select
            :items="allStatus"
            v-model="table.filters.status"
            item-text="text"
            item-value="id"
            menu-props="auto"
            label="Status"
            hide-details
            single-line
            solo
            color="primary"
            dense
        ></v-select>
      </v-col>
    </v-row>

    <v-row class="fill-height elevation-1 mx-0 mt-4" v-if="viewType === 'CALENDAR'">
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
            >
              Hoje
            </v-btn>
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>

            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-menu
                bottom
                right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Dia</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mês</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 dias</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>

        <v-sheet height="600">
          <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="events"
              :event-color="getEventColor"
              :type="type"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
          ></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

    <v-data-table
        v-if="viewType === 'LIST'"
        v-model="table.selected"
        :headers="table.headers"
        :server-items-length="getTotalItems()"
        :items="tasks ? tasks.data : []"
        :items-per-page="tasks && tasks.meta ? parseInt(tasks.meta.per_page) : 0"
        :page.sync="table.page"
        :options.sync="table.options"
        :sort-by.sync="table.sortBy"
        :sort-desc.sync="table.sortDesc"
        :loading="table.loading"
        @click:row="rowClick"
        hide-default-footer
        item-key="name"
        class="elevation-1 mt-4"
    >
      <template v-slot:top>
        <v-row class="px-3">
          <v-col cols="12" sm="6" md="3" xs="12">
            <date-picker
                clearable
                label="De"
                noIcon
                outlined
                dense
                v-on:change="changeSchedulingDateStart"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" xs="12">
            <date-picker
                clearable
                label="Até"
                noIcon
                outlined
                dense
                v-on:change="changeSchedulingDateEnd"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-pagination
            class="mb-4"
            v-model="table.page"
            :length="tasks && tasks.meta ? Math.floor(parseInt(tasks.meta.total) / parseInt(tasks.meta.per_page)) : 0"
        ></v-pagination>
      </template>
    </v-data-table>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <schedule-info-modal
        :id="get(itemSelected, 'id')"
        :open="openDetail"
        :onExecuteTask="onExecuteTask"
        :onCancelTask="onCancelTask"
        :onClose="closeDetails"
        title="Detalhes do agendamento"
        :show-execute-action="get(itemSelected, 'status') === 'ERROR'"
        :show-cancel-action="get(itemSelected, 'status') === 'WAITING'"
    >
      <p>ID: <strong>{{ get(itemSelected, 'id') }}</strong></p>
      <p>Agendado em: <strong>{{ get(itemSelected, 'created_at_formatted') }}</strong></p>
      <p>Data de início: <strong>{{ get(itemSelected, 'date_formatted') }}</strong></p>
      <p v-if="get(itemSelected, 'task_child.id')">Data de término: <strong>{{ get(itemSelected, 'task_child.date_formatted') }}</strong></p>
      <p>Usuário: <strong>{{  get(itemSelected, 'user.name') }}</strong></p>
      <p>Status: <strong>{{ get(itemSelected, 'status_formatted') }}</strong></p>
      <p>Tipo: <strong>{{ get(itemSelected, 'type_formatted') }}</strong></p>
      <p>Atualização em massa: <strong>{{ get(itemSelected, 'bulk') ? 'Sim' : 'Não' }}</strong></p>
    </schedule-info-modal>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import {handleResponseError} from '@/api/handleError'
import {mapState} from 'vuex'
import { get } from 'lodash'
import ScheduleInfoModal from '@/views/Locations/Modals/ScheduleInfoModal'

export default {
  name: 'LocationSchedulesTab',
  components: {
    DatePicker,
    ScheduleInfoModal
  },
  computed: {
    ...mapState({
      tasks: state => state.locations.tasks,
      location: state => state.locations.location
    }),
    get() {
      return get
    }
  },
  data: () => ({
    openDetail: false,
    itemSelected: {
      id: 0
    },
    allStatus: [
      { id: '', text: 'Todos' },
      { id: 'WAITING', text: 'Aguardando' },
      { id: 'ERROR', text: 'Com erro' },
      { id: 'OK', text: 'Concluído' },
      { id: 'RUNNING', text: 'Executando' },
    ],
    sortBy: '',
    sortDesc: '',
    limit: 10,
    page: 1,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    table: {
      loading: false,
      filters: {
        selectValue: null,
        selectOptions: [],
        dateStart: '',
        dateEnd: '',
        status: '',
      },
      headers: [
        { text: 'Id', value: 'id', align: 'start' },
        { text: 'Data', value: 'date_formatted' },
        { text: 'Tipo', value: 'type_formatted' },
        { text: 'Status', value: 'status_formatted' },
        { text: 'Agendado em', value: 'created_at_formatted' },
        { text: 'Agendado por', value: 'user.name', sortable: false },
      ],
      page: 1,
      sortBy: null,
      sortDesc: false,
      options: {},
    },
    scheduling_date: '',
    viewType: 'CALENDAR',
    viewTypes: [
      { id: 'CALENDAR', text: 'Calendário' },
      { id: 'LIST', text: 'Lista' },
    ],
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Mês',
      week: 'Semana',
      day: 'Dia',
      '4day': '4 Dias',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
  }),
  mounted() {
    this.$refs.calendar.checkChange()
  },
  created() {
    const id = this.$route.params.id
    if (!id) {
      this.showNotification('Nenhum local encontrado', 'red darken-2')
    } else {
      this.id = id
    }
  },
  methods: {
    fetchTasks: async function() {
      this.table.loading = true

      await this.$store.dispatch('locations/getTasks', {
        id: this.id,
        params: {
          account: this.location.data.account_name,
          date_start: this.table.filters.dateStart,
          date_end: this.table.filters.dateEnd,
          limit: this.limit,
          page: this.page,
          sort_direction: this.sortDesc ? 'desc' : 'asc'
        }
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os agendamentos.')
        this.showNotification(message, 'red darken-2')
        this.table.loading = false
      })
      this.table.loading = false
    },
    changeSchedulingDateStart(date) {
      this.table.filters.dateStart = date
      this.fetchTasks()
    },
    changeSchedulingDateEnd(date) {
      this.table.filters.dateEnd = date
      this.fetchTasks()
    },
    viewDay({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    getColorByStatus(status) {
      switch (status) {
        case 'WAITING':
          return 'blue'
        case 'ERROR':
          return 'red'
        case 'OK':
          return 'green'
        case 'RUNNING':
          return 'cyan'
      }
    },
    showEvent({nativeEvent, event}) {
      this.openDetails()
      this.itemSelected = event.data
      nativeEvent.stopPropagation()
    },
    updateRange({start, end}) {
      this.sortBy = ''
      this.page = 1
      this.limit = 31
      this.table.filters.dateStart = start.date
      this.table.filters.dateEnd = end.date
      if (start.date != end.date) {
        this.fetchTasks()
      }
    },
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    getTotalItems: function() {
      return this.tasks && this.tasks.meta ? parseInt(this.tasks.meta.total) : 0
    },
    rowClick: function(task) {
      this.openDetails()
      this.itemSelected = task
    },
    parseDate: function(date) {
      const [year, month, dayWithTime] = date.split('-')
      const [day, time] = dayWithTime.split(' ')
      const [hours, minutes, seconds] = time.split(':')
      return new Date(year, parseInt(month) - 1, day, hours, minutes, seconds)
    },
    openDetails: function() {
      this.openDetail = true
    },
    closeDetails: function() {
      this.openDetail = false
    },
    onExecuteTask: async function () {
      this.showNotification('Agendamento concluído!', 'green')
      this.closeDetails()
      await this.fetchTasks()
    },
    onCancelTask: async function () {
      this.showNotification('Agendamento cancelado!', 'green')
      this.closeDetails()
      await this.fetchTasks()
    },
    parseEvents(tasks) {
      return tasks.map(task => {
        return {
          name: task.type_formatted,
          start: this.parseDate(task.date),
          end: task.task_child && this.parseDate(task.task_child.date),
          color: this.getColorByStatus(task.status),
          timed: true,
          data: task
        }
      })
    }
  },
  watch: {
    'table.options': function(options) {
      let sortBy = options.sortBy[0]
      const sortDesc = options.sortDesc[0]
      if ((sortBy || '').includes('formatted')) {
        const s = sortBy.split('_formatted')
        sortBy = s[0]
      }

      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.page = options.page
      this.limit = 10
      this.fetchTasks()
    },
    'table.filters.status': function() {
      this.fetchTasks()
    },
    viewType: function (value) {
      if (value === 'LIST') {
        this.limit = 10
      }
    },
    tasks: function(tasks) {
      const t = tasks && Array.isArray(tasks.data) && tasks.data.filter(t => !t.task_id)
      this.events = this.parseEvents(t)
    }
  }
}
</script>

<style scoped>

</style>
